import React from "react";
import PropTypes from "prop-types";
import BannerVerticalCarousel from "./BannerVerticalCarousel";
import speaker from "../../../assets/images/kmc-images/speaker-imp-ann.png";
import stethoscope from "../../../assets/images/kmc-images/stethoscope.png";

const VerticalImpBlock = ({ visits, Important, checkBothExpired, imp1 }) => {
  const visitsItems = () => {
    return visits?.length > 0 ? (
      <>
        <div className="upcoming-s-visitors">
          <h2>
            <img src={stethoscope} alt="" className="me-4 stethoscope" />{" "}
            <span>Upcoming Specialist Visits</span>
          </h2>
        </div>
        <BannerVerticalCarousel carouselItems={visits} />
      </>
    ) : (
      ""
    );
  };

  const ImportantItems = () => {
    const visitsItemsMap = Important?.map((items) => {
      return (
        <>
          {items.type === "kmc_open_close_status" ? (
            <>
              <div>
                <p className="p-kmc">
                  <span className="check-box" />
                  {items.message}
                </p>
              </div>
            </>
          ) : null}
        </>
      );
    });
    return Important.length > 0 && imp1.includes("true") ? (
      <div
        className={
          Important.length > 1 && visits?.length > 0
            ? "imp_scroll"
            : "imp_scroll2"
        }
      >
        <div className="imp-announcement">
          <h2>
            <img src={speaker} alt="" className="me-4" />{" "}
            <span>IMP Announcements</span>
          </h2>
        </div>
        {visitsItemsMap}
      </div>
    ) : (
      ""
    );
  };
  return checkBothExpired() ? (
    <div className="App">
      {visitsItems()}
      {ImportantItems()}
    </div>
  ) : (
    ""
  );
};

VerticalImpBlock.propTypes = {
  visits: PropTypes.string.isRequired,
  Important: PropTypes.string.isRequired,
  checkBothExpired: PropTypes.func.isRequired,
  imp1: PropTypes.string.isRequired,
};
export default VerticalImpBlock;
